module.exports = __webpack_public_path__ + "system/img/none-008.0c333bf0.png";